import { useEffect } from "react";
import React from "react"
import { Outlet } from "react-router-dom";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { reloadWindowToPath } from "../Helpers/Utils";

const PublicRouters = ({ children }) => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      reloadWindowToPath("/booking/1");
    }
  }, [isAuthenticated]);
  
  return (
    <React.Fragment>
      {!isAuthenticated && (
        <>
          {children}
          <Outlet />
        </>
      )}
    </React.Fragment>
  );
}

export default PublicRouters
